import { render, staticRenderFns } from "./PerformanceChart.vue?vue&type=template&id=0852b687&scoped=true&"
import script from "./PerformanceChart.vue?vue&type=script&lang=js&"
export * from "./PerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceChart.vue?vue&type=style&index=0&id=0852b687&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0852b687",
  null
  
)

export default component.exports